module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-eBook-w720.151ad3f0.webp";